import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from "react";
import { useTranslate } from "@bluelibs/x-ui";
import Quill from "quill";
import "quill/dist/quill.snow.css"; // Import Quill styles
export const RichTextEditor = ({ value, onChange, placeholder, }) => {
    const editorRef = useRef(null);
    const quillRef = useRef(null);
    const t = useTranslate();
    useEffect(() => {
        if (editorRef.current && !quillRef.current) {
            const toolbarOptions = [
                ["bold", "italic", "underline", "strike"],
                ["blockquote", "code-block"],
                [{ header: 1 }, { header: 2 }],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ script: "sub" }, { script: "super" }],
                [{ indent: "-1" }, { indent: "+1" }],
                [{ size: ["small", false, "large", "huge"] }],
                [{ color: [] }, { background: [] }],
                [{ align: [] }],
                ["clean"],
                ["link"],
            ];
            quillRef.current = new Quill(editorRef.current, {
                modules: {
                    toolbar: toolbarOptions,
                },
                placeholder: placeholder || t("components.richTextEditor.placeholder"),
                theme: "snow",
            });
            // Set initial content
            quillRef.current.root.innerHTML = value;
            // Handle content changes
            quillRef.current.on("text-change", () => {
                if (quillRef.current) {
                    const content = quillRef.current.root.innerHTML;
                    onChange(content);
                }
            });
        }
        // Cleanup
        return () => {
            if (quillRef.current) {
                quillRef.current.off("text-change");
            }
        };
    }, []);
    // Update content if value prop changes
    useEffect(() => {
        if (quillRef.current && value !== quillRef.current.root.innerHTML) {
            quillRef.current.root.innerHTML = value || "";
        }
    }, [value]);
    return (_jsx("div", Object.assign({ className: "rich-text-editor" }, { children: _jsx("div", { ref: editorRef }, void 0) }), void 0));
};
